import { useEffect, useState } from "react";
import Modal from "react-modal";
import { CustomText } from "../components";
import Button from "../components/core_component/Button";
import Icon from "../components/core_component/icon";
import Core from "../common/clientSdk";
import { toast } from "react-toastify";

export const InfluencerAnalyticsShareLink = ({
    closeModal,
    campaignId,
    assignment_share_key,
    sectionVisibility = {},
}) => {
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const [url, setUrl] = useState(null);

    console.log("assignment_share_key", assignment_share_key);

    useEffect(() => {
        if (!assignment_share_key) {
            getGenerateShareKeyCampaignContractsList();
        } else {
            setUrl(assignment_share_key);
        }
    }, []);

    function getGenerateShareKeyCampaignContractsList() {
        var params = {
            campaign_id: campaignId,
            // Pass visibility settings to the API
            visibility: JSON.stringify({
                overview: sectionVisibility.overview !== false,
                timeline: sectionVisibility.timeline !== false,
                topPerformers: sectionVisibility.topPerformers !== false,
                influencers: sectionVisibility.influencers !== false,
                content: sectionVisibility.content !== false,
            }),
        };

        Core.generateShareKeyCampaignContractsList(
            getGenerateShareKeyCampaignContractsListSuccess,
            getGenerateShareKeyCampaignContractsListFailed,
            (status) => setLoading(status),
            params,
        );
    }

    function getGenerateShareKeyCampaignContractsListSuccess(response) {
        setUrl(response.share_key);
    }

    function getGenerateShareKeyCampaignContractsListFailed(error) {
        const msg = Array.isArray(error)
            ? error.map((item) => item.m).join(",")
            : typeof error === "string"
              ? error
              : "Could not generate share link";
        toast.error(msg);
    }

    function constructUrl(share_key) {
        if (window.location.hostname == "localhost") {
            return `http://${window.location.host}/analytics/share/${share_key}`;
        } else {
            return `https://${window.location.host}/analytics/share/${share_key}`;
        }
    }

    const copyToClipboard = () => {
        console.log("navigator", navigator);

        if (!navigator.clipboard) {
            console.error("Clipboard API not supported");
            return;
        }

        navigator.clipboard
            .writeText(constructUrl(url))
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <Modal isOpen={true} onRequestClose={closeModal} style={CancelReminder}>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    background: "#ffffff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 30,
                    paddingTop: 15,
                }}
            >
                <div className="collection-link-copy-header">
                    <CustomText
                        h5
                        text={"Share Campaign"}
                        textColor={"text_grey_400_color"}
                        className="m-b-20 typography-centerH7"
                    />
                    <div onClick={closeModal} className="close-btn-icon">
                        <Icon iconName="CloseRoundButtonIcon" />
                    </div>
                </div>
            </div>
            <div className="share-collection-popout" style={{ paddingTop: 40 }}>
                <div className="collection-sheet-url-container">
                    <input
                        type="text"
                        readOnly
                        className="collection-sheet-url-input"
                        value={
                            loading
                                ? "generate url..."
                                : url
                                  ? constructUrl(url)
                                  : ""
                        }
                        placeholder={"e.g. https://mystore.com/analytics"}
                        style={{
                            flex: 1,
                            padding: "10px 12px",
                            border: "1px solid #e5e7eb",
                            borderRadius: 8,
                            fontSize: 14,
                        }}
                    />
                    {/* <button onClick={copyToClipboard} style={{
                        background: '#1977f2',
                        color: '#ffffff'
                    }}>
                        {copied ? "Copied!" : "Copy link"}
                    </button> */}
                    <Button
                        onClick={() => copyToClipboard()}
                        isLoading={loading}
                        disabled={loading}
                        width={100}
                        height={41.5}
                    >
                        {copied ? "Copied!" : "Copy link"}
                    </Button>
                </div>

                <div className="collection-link-regenerate">
                    <CustomText
                        p
                        text={"Disable/Regenerate previously generated link:"}
                        className="button1"
                        textColor="text_grey_100_color"
                    />
                    <div
                        onClick={getGenerateShareKeyCampaignContractsList}
                        className="share-icon-regenrate"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                            height: 15,
                        }}
                    >
                        <div style={{ marginTop: 2 }}>
                            <Icon iconName="regenerateUrlIcon" />
                        </div>

                        <CustomText
                            p
                            text={"Regenerate"}
                            className="button-text m-l-5"
                            textColor="text_grey_100_color"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const CancelReminder = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        background: "#ffffff",
        textAlign: "center",
        zIndex: "5",
        display: "flex",
        flexDirection: "column",
        minWidth: "460px",
        maxWidth: 516,
        width: "100%",
        minHeight: "150px",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.95)",
        zIndex: 10,
    },
};
